import React, { useEffect, useState, useCallback } from 'react';

import { Col, Container, Row } from 'react-bootstrap';

import api from '../../services/api';
import getResponseErrors from '../../utils/getResponseErrors';
import { useToast } from '../../hooks/toast';
import ItemAgendaSalas from './ItemAgendaSalas';
import Loading from '../../components/Loading';
import TokenPainel from './TokenPainel';
import PacientesChamados from './PacientesChamados';
import { PermissionProvider } from '../../services/PermissionProvider';
import { useAuth } from '../../hooks/auth';

type AgendaSala = IAgendaSala[];

export interface IAgendaSala {
  ConCodigo: number;
  ConNome: string;
  NomeSala: string;
}

const AgendaSalas: React.FC = () => {
  const { addToast } = useToast();
  const { clinica } = useAuth();
  const [loading, setLoading] = useState(false);
  const [agendaSalas, setAgendaSalas] = useState<AgendaSala>([]);
  const [tokenPainel, setTokenPainel] = useState<IAgendaSala>();
  const [salas, setSalas] = useState<string[]>([]);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<AgendaSala>(`/salas`);

        setAgendaSalas(response.data.filter(ag => ag.ConCodigo > 0));

        const token = {
          ConCodigo: clinica.CliCodigo * -1,
          ConNome: 'TOKEN ACESSO PAINEL',
          NomeSala: '',
          ...response.data.find(ag => ag.ConCodigo === clinica.CliCodigo * -1),
        };

        setTokenPainel(token);
        setSalas(
          response.data
            .filter(ag => ag.NomeSala !== '' && ag.ConCodigo > 0)
            .map(a => a.NomeSala),
        );
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar disponibilidade',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }

    loadDados();
  }, [addToast]);

  const handleAlteraAgendaSala = useCallback((agendaSala: IAgendaSala) => {
    setAgendaSalas(state => {
      if (state) {
        const indexAgendaSala = state.findIndex(
          ag => ag.ConCodigo === agendaSala.ConCodigo,
        );
        if (!indexAgendaSala) return state;
        return state.map((a, index) => {
          if (index === indexAgendaSala) return { ...a, ...agendaSala };
          return a;
        });
      }
      return [];
    });
  }, []);

  return (
    <PermissionProvider permissions={['ATENDENTE']}>
      <Container fluid className="mt-2">
        {loading && <Loading backgroundBlack={false} />}
        <div
          className="bg-white border p-2 mb-2"
          style={{ minHeight: '400px' }}
        >
          <h2>Configuração de consultórios</h2>
          <p className="my-4">Aloca agenda a um consultório específico.</p>

          {agendaSalas && agendaSalas.length > 0 && (
            <Row noGutters>
              <Col>
                <Row noGutters className="bg-light text-dark pt-1 pb-2 pl-1">
                  <Col md={1} className="px-1">
                    ID
                  </Col>
                  <Col md={5} className="px-1">
                    Agenda
                  </Col>

                  <Col md={4} className="px-1">
                    Local
                  </Col>
                  <Col md={2} className="px-1">
                    -
                  </Col>
                </Row>
                {agendaSalas?.map(sala => (
                  <ItemAgendaSalas
                    key={`itens-${sala.ConCodigo}-${Math.random() * 9999999}`}
                    handleAltera={handleAlteraAgendaSala}
                    agendaSala={sala}
                    salas={salas}
                  />
                ))}
              </Col>
            </Row>
          )}
        </div>

        <div
          className="bg-white border p-2 mb-2"
          style={{ minHeight: '200px' }}
        >
          <h2>Configuração do Painel</h2>
          <p className="my-4">
            Mídia de fundo e Token utilizado para abrir o painel de chamados.
          </p>

          <Row noGutters>
            <Col>
              {tokenPainel && <TokenPainel tokenPainel={tokenPainel} />}
            </Col>
          </Row>
        </div>

        <div
          className="bg-white border p-2 mb-2"
          style={{ minHeight: '400px' }}
        >
          <h2>Pacientes Chamados</h2>
          <p className="my-4">Lista de pacientes chamados no painel.</p>

          <Row noGutters>
            <Col>
              <PacientesChamados CliCodigo={clinica.CliCodigo} />
            </Col>
          </Row>
        </div>
      </Container>
    </PermissionProvider>
  );
};

export default AgendaSalas;
